import { AxiosInstance } from "axios";
import PrecatioService from "../api/Precatorio.service";
import CommonDomainService from "../api/CommonDomain.service";
import TradeService from "../api/Trade.service";
import PricingService from "../api/Pricing.service";
import CorrectionTableService from "../api/CorrectionTable.service";
import DocumentService from "../api/Document.service";
import UserService from "../api/User.service";
import ViaCepService from "../api/ViaCep.service";
import ProfileService from "../api/Profile.service";
import RuleService from "../api/Rule.service";
import ScreenService from "../api/Screen.service";
import ResourceService from "../api/Resource.service";
import OfficerService from "../api/Officer.service";
import DapConsultService from "../api/DapConsult.service";
import DiligenceReportService from "../api/DiligenceReport.service";
import { UserAuthService } from "../api/UserAuth.service";
import LawFirmService from "../api/LawFirm.service";
import BigDataCorpService from "../api/BigDataCorp.service";
import UniproofService from "../api/Uniproof.service";
import TradeApprovalPhaseLogService from "../api/TradeApprovalPhaseLog.service";
import SpecialProjectService from "../api/SpecialProject.service";
import TradePhaseService from "../api/TradePhase.service";
import DigestoService from "../api/Digesto.service";
import MountedEmailService from "../api/MountedEmail.service";
import SpecialProjectDocumentService from "../api/SpecialProjectDocument.service";
import TradeContingencyService from "../api/TradeContingency.service";
import CredDefenseService from "../api/CredDefense.service";
import FraudService from "../api/Fraud.service";
import { BCheckService } from "../api/BCheck.service";
import BoilerplateEmailService from "../api/BoilerplateEmail.service";
import TemplateEmailService from "../api/TemplateEmail.service";
import ThesisService from "../api/Thesis.service";
import PendencyService from "../api/Pendency.service";
import { ReportService } from "../api/Report.service";
import TradePostPurchaseService from "../api/TradePostPurchase.service";
import CartorioService from "../api/Cartorio.service";
import SigningConfigurationService from "../api/SigningConfiguration.service";
import FileService from "../api/File.service";
import PricingBatchService from "../api/PricingBatch.service";
import OperationCostService from "../api/OperationCost.service";
import IntegrationService from "../api/Integration.service";
import LegalProcessDiligenceService from "../api/LegalProcessDiligence.service";
import EmailService from "../api/EmailApproval.service";
import TicketRequestService from "../api/TicketRequest.service";
import TicketRequestMessageService from "../api/TicketRequestMessage.service";
import TradePricingService from "../api/TradePricing.service";
import TradeSearchService from "../api/TradeSearch.service";
import SpecialProjectReportService from "../api/SpecialProjectReport.service";
import SpecialProjectCommissionService from "../api/SpecialProjectCommission.service";
import { ExpensePaymentService } from "../api/ExpensePayment.service";
import { ExpenseSearchService } from "../api/ExpenseSearch.service";
import { ExpenseRequestService } from "../api/ExpenseRequest.service";
import { ExpenseCommentService } from '../api/ExpenseComment.service';
import TradeAnalysisService from "../api/TradeAnalysis.service";
import { BCheckBatchService } from "../api/BCheckBatch.service";
import EntubaPricingService from "../api/EntubaPricing.service";
import EntubaExposureService from "../api/EntubaExposure.service";
import EntubaBCheckService from '../api/EntubaBCheck.service';
import TradePricingProposalService from '../api/TradePricingProposalService';
import LogService from '../api/Log.service';
import CourtService from "../api/Court.service";
import CourtTypeService from "../api/CourtType.service";
import CourtExpectedPaymentService from "../api/CourtExpectedPayment.service";
import { SpreadService } from "../api/Spread.service";
import CourtTypeAccrualTypeService from "../api/CourtTypeAccrualType.service";
import NatureTypeService from '../api/NatureType.service';
import OnboardingService from '../api/Onboarding.service';
import StrategyService from "../api/Strategy.service";
import BlackListService from "../api/BlackList.service";
import { AdditiveService } from '../api/Additive.service';
import EntubaPanService from "../api/EntubaPan.service";
import SettlementsService from '../api/Settlements.service';
import { FeeAdditiveService } from '../api/FeeAdditive.service';
import { BatchService } from '../api/Batch.service';
import ExceedMaxPriceBalanceService from '../api/ExceedMaxPriceBalance.service';
import ExceedMaxPriceBalanceTransactionService from '../api/ExceedMaxPriceBalanceTransaction.service';
import AutomaticSpecialSituationValidationService from "../api/AutomaticSpecialSituationValidation.service";
import { DiligenceSLAService } from "../api/DiligenceSLAService.service";
import { BlockedBalanceService } from '../api/BlockedBalance.service';
import { AccrualService } from "../api/Accrual.service";
import EntubaService from '../api/Entuba.service';
import FidcService from '../api/Fidc.service';
import DebtRolloverService from '../api/DebtRollover.service';
import DealSearchService from '../api/DealSearchService.service';
import DealPhaseService from '../api/DealPhaseService';
import DealAnalysisService from '../api/DealAnalysis.service';
import DealQuestionService from '../api/DealQuestion.service';
import PrePrecatorioService from '../api/PrePrecatorio.service';
import TicketControlService from '../api/TicketControl.service';
import DebtRolloverHistoryService from '../api/DebtRolloverHistory.service';
import ExpenseCategoryService from '../api/ExpenseCategory.service';
import AccrualsConfigService from '../api/AccrualsConfig.service';
import DiscountsConfigService from '../api/DiscountsConfig.service';
import SpecialProjectTradeControlService from '../api/SpecialProjectTradeControl.service';
import PrecatorioWholeSaleService from '../api/PrecatorioWholeSale.service';
import DiligenceReAnalyisService from '../api/DiligenceReAnalyis.service';
import EmailCampaignService from "../api/EmailCampaign.service";
import { AIService } from "../api/AI.service";
import EstateInventoryService from "../api/EstateInventory.service";
import { RequeredService } from "../api/Requered.service";
import RollbackReconcileSettlementService from "../api/RollbackReconcileSettlement.service";

export default class ServiceApi {
  public accrualService: AccrualService;
  public additiveService: AdditiveService;
  public restClient: AxiosInstance;
  public viaCepService: ViaCepService;
  public bCheckService: BCheckService;
  public precatorioService: PrecatioService;
  public commonDomainService: CommonDomainService;
  public tradeService: TradeService;
  public tradeAnalysisService: TradeAnalysisService;
  public pricingService: PricingService;
  public correctionTableService: CorrectionTableService;
  public documentService: DocumentService;
  public userService: UserService;
  public profileService: ProfileService;
  public ruleService: RuleService;
  public screenService: ScreenService;
  public resourceService: ResourceService;
  public officerService: OfficerService;
  public dapConsultService: DapConsultService;
  public diligenceReportService: DiligenceReportService;
  public userAuthService: UserAuthService;
  public lawFirmService: LawFirmService;
  public fileService: FileService;
  public cartorioService: CartorioService;
  public signingConfigurationService: SigningConfigurationService;
  public bigDataCorpService: BigDataCorpService;
  public uniproofService: UniproofService;
  public tradeApprovalPhaseLogService: TradeApprovalPhaseLogService;
  public specialProjectService: SpecialProjectService;
  public tradePhaseService: TradePhaseService;
  public digestoService: DigestoService;
  public mountedEmailService: MountedEmailService;
  public emailCampaignService: EmailCampaignService;
  public templateEmailService: TemplateEmailService;
  public thesisService: ThesisService;
  public boilerplateEmailService: BoilerplateEmailService;
  public specialProjectDocumentService: SpecialProjectDocumentService;
  public tradeContingencyService: TradeContingencyService;
  public credDefenseService: CredDefenseService;
  public fraudService: FraudService;
  public onboardingService: OnboardingService;
  public pendencyService: PendencyService;
  public reportService: ReportService;
  public tradePostPurchaseService: TradePostPurchaseService;
  public pricingBatchService: PricingBatchService;
  public bcheckBatchService: BCheckBatchService;
  public operationCostService: OperationCostService;
  public integrationService: IntegrationService;
  public legalProcessDiligenceService: LegalProcessDiligenceService;
  public emailService: EmailService;
  public ticketRequestService: TicketRequestService;
  public ticketControlService: TicketControlService;
  public ticketRequestMessageService: TicketRequestMessageService;
  public tradePricingService: TradePricingService;
  public tradeSearchService: TradeSearchService;
  public specialProjectReportService: SpecialProjectReportService;
  public specialProjectCommissionService: SpecialProjectCommissionService;
  public expenseRequestService: ExpenseRequestService;
  public expensePaymentService: ExpensePaymentService;
  public expenseSearchService: ExpenseSearchService;
  public expenseCommentService: ExpenseCommentService;
  public entubaPricingService: EntubaPricingService;
  public entubaExposureService: EntubaExposureService;
  public entubaBCheckService: EntubaBCheckService;
  public tradePricingProposalService: TradePricingProposalService;
  public logService: LogService;
  public courtService: CourtService;
  public courtTypeService: CourtTypeService;
  public courtExpectedPaymentService: CourtExpectedPaymentService;
  public spreadService: SpreadService;
  public courtTypeAccrualTypeService: CourtTypeAccrualTypeService;
  public natureTypeService: NatureTypeService;
  public strategyService: StrategyService;
  public blackListService: BlackListService;
  public expenseCategoryService: ExpenseCategoryService;
  public accrualsConfigService: AccrualsConfigService;
  public fidcService: FidcService;
  public entubaPanService: EntubaPanService;
  public settlementsService: SettlementsService;
  public debtRolloverService: DebtRolloverService;
  public debtRolloverHistoryService: DebtRolloverHistoryService;
  public feeAdditiveService: FeeAdditiveService;
  public batchService: BatchService;
  public exceedMaxPriceBalanceService: ExceedMaxPriceBalanceService;
  public exceedMaxPriceBalanceTransactionService: ExceedMaxPriceBalanceTransactionService;
  public automaticSpecialSituationValidationService: AutomaticSpecialSituationValidationService;
  public diligenceSLAService: DiligenceSLAService;
  public blockedBalanceService: BlockedBalanceService;
  public entubaService: EntubaService;
  public dealSearchService: DealSearchService;
  public dealPhaseService: DealPhaseService;
  public dealAnalysisService: DealAnalysisService;
  public dealQuestionService: DealQuestionService;
  public prePrecatorioService: PrePrecatorioService;
  public discountConfigService: DiscountsConfigService;
  public precatorioWholeSaleService: PrecatorioWholeSaleService;
  public specialProjectTradeControlService: SpecialProjectTradeControlService;
  public diligenceReAnalyisService: DiligenceReAnalyisService;
  public aiService: AIService;
  public estateInventoryService: EstateInventoryService;
  public requeredService: RequeredService;
  public rollbackReconcileSettlementService: RollbackReconcileSettlementService;

  constructor(restClient: AxiosInstance) {
    this.restClient = restClient;
    this.viaCepService = new ViaCepService();
    this.accrualService = new AccrualService(this.restClient);
    this.additiveService = new AdditiveService(this.restClient);
    this.bCheckService = new BCheckService(this.restClient);
    this.precatorioService = new PrecatioService(this.restClient);
    this.commonDomainService = new CommonDomainService(this.restClient);
    this.tradeService = new TradeService(this.restClient);
    this.tradeAnalysisService = new TradeAnalysisService(this.restClient);
    this.pricingService = new PricingService(this.restClient);
    this.correctionTableService = new CorrectionTableService(this.restClient);
    this.documentService = new DocumentService(this.restClient);
    this.userService = new UserService(this.restClient);
    this.profileService = new ProfileService(this.restClient);
    this.ruleService = new RuleService(this.restClient);
    this.screenService = new ScreenService(this.restClient);
    this.resourceService = new ResourceService(this.restClient);
    this.officerService = new OfficerService(this.restClient);
    this.dapConsultService = new DapConsultService(this.restClient);
    this.diligenceReportService = new DiligenceReportService(this.restClient);
    this.userAuthService = new UserAuthService(this.restClient);
    this.lawFirmService = new LawFirmService(this.restClient);
    this.fileService = new FileService(this.restClient);
    this.cartorioService = new CartorioService(this.restClient);
    this.signingConfigurationService = new SigningConfigurationService(this.restClient);
    this.bigDataCorpService = new BigDataCorpService(this.restClient);
    this.uniproofService = new UniproofService(this.restClient);
    this.tradeApprovalPhaseLogService = new TradeApprovalPhaseLogService(this.restClient);
    this.specialProjectService = new SpecialProjectService(this.restClient);
    this.tradePhaseService = new TradePhaseService(this.restClient);
    this.digestoService = new DigestoService(this.restClient);
    this.mountedEmailService = new MountedEmailService(this.restClient);
    this.emailCampaignService = new EmailCampaignService(this.restClient);
    this.templateEmailService = new TemplateEmailService(this.restClient);
    this.thesisService = new ThesisService(this.restClient);
    this.boilerplateEmailService = new BoilerplateEmailService(this.restClient);
    this.specialProjectDocumentService = new SpecialProjectDocumentService(this.restClient);
    this.tradeContingencyService = new TradeContingencyService(this.restClient);
    this.credDefenseService = new CredDefenseService(this.restClient);
    this.fraudService = new FraudService(this.restClient);
    this.pendencyService = new PendencyService(this.restClient);
    this.reportService = new ReportService(this.restClient);
    this.tradePostPurchaseService = new TradePostPurchaseService(this.restClient);
    this.operationCostService = new OperationCostService(this.restClient);
    this.integrationService = new IntegrationService(this.restClient);
    this.legalProcessDiligenceService = new LegalProcessDiligenceService(this.restClient);
    this.emailService = new EmailService(this.restClient);
    this.pricingBatchService = new PricingBatchService(this.restClient);
    this.bcheckBatchService = new BCheckBatchService(this.restClient);
    this.ticketRequestService = new TicketRequestService(this.restClient);
    this.ticketControlService = new TicketControlService(this.restClient);
    this.ticketRequestMessageService = new TicketRequestMessageService(this.restClient);
    this.tradePricingService = new TradePricingService(this.restClient);
    this.tradeSearchService = new TradeSearchService(this.restClient);
    this.specialProjectReportService = new SpecialProjectReportService(this.restClient);
    this.specialProjectCommissionService = new SpecialProjectCommissionService(this.restClient);
    this.expenseRequestService = new ExpenseRequestService(this.restClient);
    this.expensePaymentService = new ExpensePaymentService(this.restClient);
    this.expenseSearchService = new ExpenseSearchService(this.restClient);
    this.expenseCommentService = new ExpenseCommentService(this.restClient);
    this.entubaPricingService = new EntubaPricingService(this.restClient);
    this.entubaExposureService = new EntubaExposureService(this.restClient);
    this.entubaBCheckService = new EntubaBCheckService(this.restClient);
    this.tradePricingProposalService = new TradePricingProposalService(this.restClient);
    this.logService = new LogService(this.restClient);
    this.courtService = new CourtService(this.restClient);
    this.courtTypeService = new CourtTypeService(this.restClient);
    this.courtExpectedPaymentService = new CourtExpectedPaymentService(this.restClient);
    this.spreadService = new SpreadService(this.restClient);
    this.courtTypeAccrualTypeService = new CourtTypeAccrualTypeService(this.restClient);
    this.natureTypeService = new NatureTypeService(this.restClient);
    this.onboardingService = new OnboardingService(this.restClient);
    this.strategyService = new StrategyService(this.restClient);
    this.blackListService = new BlackListService(this.restClient);
    this.expenseCategoryService = new ExpenseCategoryService(this.restClient);
    this.accrualsConfigService = new AccrualsConfigService(this.restClient);
    this.fidcService = new FidcService(this.restClient);
    this.entubaPanService = new EntubaPanService(this.restClient);
    this.settlementsService = new SettlementsService(this.restClient);
    this.debtRolloverService = new DebtRolloverService(this.restClient);
    this.feeAdditiveService = new FeeAdditiveService(this.restClient);
    this.batchService = new BatchService(this.restClient);
    this.exceedMaxPriceBalanceService = new ExceedMaxPriceBalanceService(this.restClient);
    this.exceedMaxPriceBalanceTransactionService = new ExceedMaxPriceBalanceTransactionService(this.restClient);
    this.automaticSpecialSituationValidationService = new AutomaticSpecialSituationValidationService(this.restClient);
    this.diligenceSLAService = new DiligenceSLAService(this.restClient);
    this.blockedBalanceService = new BlockedBalanceService(this.restClient);
    this.entubaService = new EntubaService(this.restClient);
    this.dealSearchService = new DealSearchService(this.restClient);
    this.dealPhaseService = new DealPhaseService(this.restClient);
    this.dealAnalysisService = new DealAnalysisService(this.restClient);
    this.dealQuestionService = new DealQuestionService(this.restClient);
    this.prePrecatorioService = new PrePrecatorioService(this.restClient);
    this.precatorioWholeSaleService = new PrecatorioWholeSaleService(this.restClient);
    this.debtRolloverHistoryService = new DebtRolloverHistoryService(this.restClient);
    this.discountConfigService = new DiscountsConfigService(this.restClient);
    this.specialProjectTradeControlService = new SpecialProjectTradeControlService(this.restClient);
    this.diligenceReAnalyisService = new DiligenceReAnalyisService(this.restClient);
    this.aiService = new AIService(this.restClient);
    this.estateInventoryService = new EstateInventoryService(this.restClient);
    this.requeredService = new RequeredService(this.restClient);
    this.rollbackReconcileSettlementService = new RollbackReconcileSettlementService(this.restClient);
  }
}
